const collectionReadMoreDescription = () => {
    let visible = false;
    const descriptionVisibility = () => {
        const readMoreDescription = document.querySelector('read-more-description');
        const readMoreElements = readMoreDescription === null || readMoreDescription === void 0 ? void 0 : readMoreDescription.querySelectorAll('.read-more__content > *');
        const readMoreButton = readMoreDescription === null || readMoreDescription === void 0 ? void 0 : readMoreDescription.querySelector('.read-more__button');
        if (readMoreDescription && readMoreElements && readMoreButton) {
            if (visible == false) {
                let i = 1;
                readMoreElements.forEach((element) => {
                    if (i > 2) {
                        element.style.display = 'none';
                    }
                    i++;
                });
            }
            else {
                readMoreButton.style.display = 'none';
            }
            readMoreButton.addEventListener('click', () => {
                visible = true;
                readMoreElements.forEach((element) => {
                    element.style.display = 'block';
                });
                readMoreButton.style.display = 'none';
            });
        }
    };
    descriptionVisibility();
    const collectionSection = document.querySelector('.shopify-section--main-collection');
    if (collectionSection) {
        const observerOptions = {
            attributes: true,
        };
        const observer = new MutationObserver(descriptionVisibility);
        observer.observe(collectionSection, observerOptions);
    }
};
export { collectionReadMoreDescription };
